import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const attend = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Ticket purchased", { props: { triggerType: "Order Submitted", event: "Workshop ticket" } }],
  ["e1", "auto-email", "You're in — venue and parking", { props: { subject: "Your ticket + everything you need on the day" } }],
  ["w1", "auto-wait", "Wait 1 week", { props: { duration: "1", unit: "weeks" } }],
  ["e2", "auto-email", "What to bring", { props: { subject: "One week out — here's the prep" } }],
  ["s1", "auto-sms", "Tomorrow, 9am", { props: { message: "See you tomorrow at 9am — {{contact.venue}}. Reply if you're stuck." } }],
  ["tg", "auto-tag-add", "Tag: attending", { props: { tag: "attending" } }],
]);

const after = column("f2", 100, 70, 92, [
  ["t2", "auto-trigger", "Workshop ended", { props: { triggerType: "Scheduled", event: "Event end + 2 hours" } }],
  ["e3", "auto-email", "Slides and recording", { props: { subject: "Everything from today, in one place" } }],
  ["w2", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["c1", "auto-condition", "Actually turned up?", { props: { condition: "Has tag 'checked-in'" } }],
  ["e4", "auto-email", "The next-level program", { props: { subject: "Ready to go deeper? Attendee pricing inside" } }],
]);

const def: TemplateDef = {
  slug: "workshop-ticket-sales",
  name: "Workshop & Event Tickets",
  category: "Events",
  tagline:
    "Sell the seat, get them in the room, then sell the thing that comes after.",
  description:
    "A free in-person event template: ticket purchase triggers a logistics email, a prep email a week out and a morning-of text, then a post-event flow sends the recap and makes the attendee-only offer. Clone it into FrazzleCRM and run the whole workshop from one map.",
  whatsInside: [
    "Ticket-purchase trigger with venue, parking and prep emails",
    "Morning-of SMS — the difference between sold seats and full seats",
    "Post-event flow with the recap and materials",
    "Attended? branch so the follow-up offer only goes to people who came",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-email", "Email list", 40, 60, { props: { list: "Local list" } }),
      node("src2", "traffic-direct", "Partners & venues", 40, 220, { props: { source: "Co-promotion" } }),
      node("sp", "page-sales", "Workshop page", 360, 140, { props: { price: "$149" } }),
      node("co", "page-checkout", "Ticket checkout", 680, 140, { props: { price: "$149", bump: "Bring a colleague — $99" } }),
      flow("f1", "Show-Up Sequence", 1000, 40, 420, 672),
      ...attend.nodes,
      node("ev", "page-web", "The workshop", 1500, 140, { props: { pageType: "landing", headline: "Live, one day, 20 seats" } }),
      flow("f2", "Post-Event", 1820, 40, 420, 580),
      ...after.nodes,
      node("up", "page-upsell", "Next-level program", 2340, 260, { props: { price: "$1,200" } }),
      node("out", "outcome-sale", "Program sale", 2660, 260, { props: { value: "$1,200" } }),
    ],
    [
      edge("src1", "sp"),
      edge("src2", "sp"),
      edge("sp", "co"),
      edge("co", "f1"),
      ...attend.edges,
      edge("f1", "ev"),
      edge("ev", "f2"),
      ...after.edges,
      edge("f2", "up"),
      edge("up", "out"),
    ]
  ),
};

export default def;
